module.exports = __webpack_public_path__ + "img/GH-kyujin-top-007.c1c15c11.webp";